"use client";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useDictionary } from "@/core/hooks/use-dictionary";
import { setCookie } from "cookies-next";
import { usePathname, useRouter } from "next/navigation";
export default function SelectLanguage() {
  const router = useRouter()
  const pathname = usePathname();
  const { dictionary } = useDictionary();
  const handleLanguageChange = (newLocale: string) => {
    setCookie('locale', newLocale, {
      maxAge: 30 * 24 * 60 * 60,
      path: '/',
    });

    const pathnameWithoutLocale = pathname.replace(
      /^\/([a-z]{2}(-[A-Z]{2})?)(?=\/|$)/,
      ''
    );

    const newPathname =
      pathnameWithoutLocale === '' || pathnameWithoutLocale === '/'
        ? `/${newLocale}`
        : `/${newLocale}${pathnameWithoutLocale}`;

    router.push(`${newPathname}${window.location.search}`);
  };


  return (
    <div>
      <Select onValueChange={handleLanguageChange}>
        <SelectTrigger className="w-45">
          <SelectValue placeholder={dictionary.ui?.language.selectLanguage} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectItem value="fa">{dictionary.ui?.language.fa}</SelectItem>
            <SelectItem value="en">{dictionary.ui?.language.en}</SelectItem>
            <SelectItem value="ar">{dictionary.ui?.language.ar}</SelectItem>
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
}
